<template>

    <div id="cms-layout">

        <div class="app-topbar">
            <div class="title-bar">
                <div class="logo">
                    <a href="#" @click.prevent="navigateHome()">
                        <i class="img logo-aveco-white-36h"></i>
                    </a>
                </div>

                <app-switcher current="loggers"></app-switcher>

                <div class="user">
                    <div class="user-info">
                        <span>{{ $user.firstName }} {{ $user.lastName }}</span>
                        <a href="#" @click.prevent="logout()">Uitloggen</a>
                    </div>
                    <div class="avatar">{{ $user | userInitials }}</div>
                </div>
            </div>
        </div>

        <nav id="cms-sidebar" :class="{ show: slideMenuVisible }">
            <div class="toggle-menu">
                <a href="#" @click.prevent="slideMenuVisible = !slideMenuVisible"><i class="magicon-menu"></i></a>
            </div>
            <router-link :to="resolvedHomeRoute" id="client-logo"><i class="svg"></i></router-link>

            <cms-menu>
                <cms-menu-group title="Menu">
                    <a href="#" @click.prevent="logout()">Uitloggen</a>
                </cms-menu-group>
                <cms-menu-item title="Overzicht loggers" icon="magicon-tiles" route="loggers"></cms-menu-item>
                <cms-menu-item title="Selectie maken" icon="magicon-ok-circle" route="select-loggers"></cms-menu-item>
                <cms-menu-item v-if="isAdminOrAdvisor" title="Reparaties" icon="entypo-tools" route="repairs"></cms-menu-item>
                <cms-menu-item title="Acties" icon="entypo-flag" route="actions"></cms-menu-item>
                <cms-menu-item v-if="isAdminOrAdvisor" title="Projecten" icon="entypo-archive" route="projects"></cms-menu-item>
                <cms-menu-item v-if="isAdminOrAdvisor" title="Logger types" icon="magicon-dots-hr" route="logger-types"></cms-menu-item>
            </cms-menu>
        </nav>

        <div id="cms-content-wrapper">
            <div id="cms-top-bar">
                <cms-breadcrumbs :items="$breadcrumb.get()" :active-route="$route"></cms-breadcrumbs>
            </div>

            <div id="cms-content-view">
                <router-view></router-view>
            </div>
        </div>

        <transition name="fade" :duration="200">
            <div class="cms-shader" v-if="$modal.visible.length" @click="onShaderClick">
                <modal-container class="modal-container" ref="modalContainer"></modal-container>
            </div>
        </transition>

    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'

    import { isChildOf } from 'app/directives/clickOutside'

    import UserRole from 'app/enums/UserRole'

    @Component({

        name: 'app-template'
    })
    export default class extends Vue
    {
        data(){

            return {
                slideMenuVisible: false
            }
        }

        created(){

            // Attach modal service for alerts
            this.$alert.attachModalService(this.$modal);

            // Close menu after navigation
            this.$router.afterEach(() => {
                this.slideMenuVisible = false;
            });
        }

        get resolvedHomeRoute(){

            return { name: di.get('config').homeRoute };
        }

        navigateHome(){

            this.$router.replace(this.resolvedHomeRoute);
        }

        go(direction){

            this.$router.go(direction);
        }

        logout() {

            di.get('auth').logout();
        }

        onShaderClick(e){

            const target = e.target;
            const modalContainer = this.$refs.modalContainer ? this.$refs.modalContainer.$el : null;

            if(modalContainer && isChildOf(modalContainer, target)){

                // Close current modal
                this.$modal.cancelTopModal();
            }
        }

        get isAdminOrAdvisor(){

            return [UserRole.ADVISOR, UserRole.ADMIN].indexOf(this.$user.role) >= 0;
        }
    }

</script>
